module.exports = __webpack_public_path__ + "static/img/wenhua8.d1e1711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua8.jpg
// module id = CwD4
// module chunks = 1